import Vue from 'vue';
import LicenceAreas from '@/resources/licence-areas';
import LicenceArea from '@/resources/licence-area';
import LicenceAreaSettings from '@/resources/licence-area-zones-settings';
import normalize from '@/lib/normalize';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'licenceArea';
const SETTINGS_MODULE_NAME = 'licenceAreaSettings';
const DEFAULT_STATE = {
  error: null,
  licenceAreas: null,
  licenceArea: null
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  mutations: {
    parseLicenceAreasResponseData(state, licenceAreas) {
      Vue.set(state, 'licenceAreas', licenceAreas);
    },
    parseLicenceAreaResponseData(state, response) {
      const licenceArea = normalize(response, { zones: true });
      Vue.set(state, 'licenceArea', licenceArea);
    },
    editLicenceArea(state, licenceArea) {
      Vue.set(state, 'licenceArea', licenceArea);
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    fetchAll({ commit }, { projectCode, reloadProjectLicenceAreas }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const action = LicenceAreas.get({ code: projectCode, include: 'zones' });

      action.then(
        response => {
          const licenceAreas = normalize(response.data, { zones: true });
          commit('parseLicenceAreasResponseData', licenceAreas);

          if (reloadProjectLicenceAreas) {
            commit(
              'projects/updateProjectsLicenceAreas',
              { projectCode, licenceAreas },
              { root: true }
            );
          }
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return action;
    },
    fetch({ commit }, { projectCode, licenceAreaCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      LicenceArea({ projectCode, licenceAreaCode }, { include: 'zones' })
        .fetch({ 'project-code': projectCode, 'licence-area-code': licenceAreaCode })
        .then(
          response => {
            commit('parseLicenceAreaResponseData', response.data);
            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          },
          () => {
            RootStateCommit(commit, 'setResponseError', MODULE_NAME);
          }
        );
    },
    update({ commit }, { projectCode, licenceAreaCode, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = LicenceArea({ projectCode, licenceAreaCode }, { include: 'zones' }).update({
        'project-code': projectCode,
        'licence-area-code': licenceAreaCode,
        ...data
      });

      res.then(
        response => {
          commit('parseLicenceAreaResponseData', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );
      return res;
    },
    create({ commit }, { projectCode, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = LicenceArea({ projectCode }, { include: 'zones', ...data }).save();

      res.then(
        response => {
          commit('parseLicenceAreaResponseData', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    },
    remove({ commit }, { projectCode, licenceAreaCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = LicenceArea({ projectCode, licenceAreaCode }).delete();

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    },
    updateSettings(
      { commit, rootState },
      { userId, assignedAllLicenceAreas, licenceAreaAndZones }
    ) {
      RootStateCommit(commit, 'startLoading', SETTINGS_MODULE_NAME);
      const res = LicenceAreaSettings.update(
        { id: userId },
        {
          assigned_all_licence_areas: assignedAllLicenceAreas,
          licence_area_and_zones: licenceAreaAndZones,
          access_token: rootState.auth.token
        }
      );

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', SETTINGS_MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', SETTINGS_MODULE_NAME);
        }
      );

      return res;
    }
  }
};
